import { UIEvent, useState } from "react";

export default function usePopupState() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const open = !!anchorEl;
  const show = (e: UIEvent) => setAnchorEl(e.currentTarget as HTMLElement);
  const hide = () => setAnchorEl(null);
  const toggle = (e: UIEvent) => (open ? hide() : show(e));

  return {
    open,
    anchorEl,
    show,
    hide,
    toggle,
    props: {
      open,
      anchorEl,
      onClose: hide,
    },
  };
}
